import { getSearchProductList, getProductList, getProductDetail } from '@/api/product'
import { getHomeList, getClassifyList, getBannerList, getContentList } from '@/api/home'

// 用户登录
export const login = ({ commit }, data) => {
  return new Promise((resolve, reject) => {
    // if (data.username === 'test' && data.password === '123456') {
    //   localStorage.setItem('loginInfo', JSON.stringify(data));
    //   commit('SET_USER_LOGIN_INFO', data);
    //   resolve(true);
    //   return true;
    // }
    localStorage.setItem('loginInfo', JSON.stringify(data));
    commit('SET_USER_LOGIN_INFO', data);
    resolve(true);
    return true;
  });
};

// 退出登陆
export const signOut = ({ commit }) => {
  localStorage.removeItem('loginInfo');
  commit('SET_USER_LOGIN_INFO', {});
};

// 判断是否登陆
export const isLogin = ({ commit }) => {
  const user = localStorage.getItem('loginInfo');
  if (user) {
    commit('SET_USER_LOGIN_INFO', JSON.parse(user));
  }
};

// 获取内容管理列表
export const loadContentList = ({ commit }, data) => {
  commit('SET_LOAD_STATUS', true);
  return new Promise((resolve, reject) => {
    getContentList(data).then((res) => {
      commit('SET_CONTENT_LIST', res.records);
      commit('SET_LOAD_STATUS', false);
    })
  });
};


// 获取首页推荐列表
export const loadHomeList = ({ commit }, data) => {
  return new Promise((resolve, reject) => {
    getHomeList(data).then((res) => {
      commit('SET_HOME_LIST', res);
    })
  });
};

// 获取轮播图
export const loadBannerList = ({ commit }, data) => {
  return new Promise((resolve, reject) => {
    getBannerList(data).then((res) => {
      commit('SET_BANNER_LIST', res.records);
    })
  });
};

// 获得筛选分类
export const loadClassifyList = ({ commit }, data) => {
  return new Promise((resolve, reject) => {
    getClassifyList(data).then((res) => {
      commit('SET_CLASSIFY_LIST', res);
      resolve(res);
    })
  });
};

// 设置当前分类Id
export const loadCurrentClassifyId = ({ commit }, data) => {
  return new Promise((resolve, reject) => {
    commit('SET_CURRENT_CLASSIFY_ID', data);
    resolve(true);
    return true;
  });
};

// 获取商品列表
export const loadGoodsList = ({ commit }, data) => {
  commit('SET_LOAD_STATUS', true);
  return new Promise((resolve, reject) => {
    getProductList(data).then((res) => {
      commit('SET_GOODS_LIST', res);
      commit('SET_LOAD_STATUS', false);
    })
  });
};

// 获取搜索商品列表
export const loadSearchGoodsList = ({ commit }, data) => {
  commit('SET_LOAD_STATUS', true);
  return new Promise((resolve, reject) => {
    getSearchProductList(data).then((res) => {
      commit('SET_SEARCH_GOODS_LIST', res);
      commit('SET_LOAD_STATUS', false);
      resolve()
    })
  });
};

// 请求获得商品详细信息
export const loadGoodsInfo = ({ commit }, data) => {
  commit('SET_LOAD_STATUS', true);
  return new Promise((resolve, reject) => {
    getProductDetail(data).then((res) => {
      commit('SET_GOODS_INFO', res);
      commit('SET_LOAD_STATUS', false);
    })
  });
};



// WEBPACK FOOTER //
// ./src/store/actions.js